<style>

.neighborhood .map-container {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: black;
    z-index:3;
}

.neighborhood .map-container img {
    width: 120vw;
    max-width: none;
}

@media screen and (max-width: 960px) {
    .neighborhood .map-container img {
        width: 200vw;
    }
}

</style>

<template>

<div class="flex-1 w-container mx-auto neighborhood">
    <div class="flex h-full flex-col">
        <div class="flex flex-col justify-center flex-1">

            <div class="fixed overflow-scroll map-container" ref="scrollContainer">
                <img src="/images/map.svg" ref="map" @load="onLoad" />
            </div>
        </div>
    </div>
</div>

</template>

<script>

export default {
    name: 'neighborhood',

    methods: {
        onLoad() {
            const scrollX = this.$refs.map.width / 4;
            const scrollY = this.$refs.map.height / 6;
            this.$refs.scrollContainer.scrollTo(scrollX, scrollY)
        }
    }
}

</script>
